import axios from 'axios';
import store from '../redux/store/store';
const API_XML_URL = import.meta.env.VITE_API_URL;

const xmlDealerService = {
  addUser: async (user) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;

      const response = await axios.post(
        `${API_XML_URL}/UserDealerShip`,
        user,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Kullanıcı eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },
  updateUser: async (user) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;

      const response = await axios.put(
        `${API_XML_URL}/UserDealerShip`,
        user,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Kullanıcı eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },

  fetchUsers: async (xmlDealerShipId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/UserDealerShip', {
        params: {
          xmlDealerShipId:xmlDealerShipId,
        }
        ,headers:{  Authorization: `Bearer ${userToken}`}
      });
    
      return response.data.data;
    } catch (error) {
      console.error('Error fetching XmlUser:', error);
      throw error;
    }
  },

  deleteUsers: async (id) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.delete('/UserDealerShip', {
        params: {
          id:id,
        }
        ,headers:{  Authorization: `Bearer ${userToken}`}
      });
    
      return response.data.data;
    } catch (error) {
      console.error('Error fetching XmlUser:', error);
      throw error;
    }
  },


  fetchXmls: async (XmlDealerShipId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/XmlDealerUser', {
        params: {
          XmlDealerShipId: XmlDealerShipId,
        }
        ,headers:{  Authorization: `Bearer ${userToken}`}
      });
    
      return response.data.data;
    } catch (error) {
      console.error('Error fetching XmlUser:', error);
      throw error;
    }
  },

  fetchDealerShip: async (UserProviderId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/XmlDealerShip', {
        params: {
          UserProviderId: UserProviderId,
        }
        ,headers:{  Authorization: `Bearer ${userToken}`}
      });
    
      return response.data.data;
    } catch (error) {
      console.error('Error fetching XmlUser:', error);
      throw error;
    }
  },


  addXml: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;

      const response = await axios.post(
        `${API_XML_URL}/XmlDealerSetting`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Kullanıcı eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },


  deleteXml: async (id) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.delete('/UserDealerShip', {
        params: {
          id:id,
        }
        ,headers:{  Authorization: `Bearer ${userToken}`}
      });
    
      return response.data.data;
    } catch (error) {
      console.error('Error fetching XmlUser:', error);
      throw error;
    }
  },
 
}
export default xmlDealerService;
